module.exports = __webpack_public_path__ + "img/warranty_en.172bb955.png";